import { jsx } from "react/jsx-runtime";
import styled from "styled-components";
import { baseStyles } from "./BaseStyles.js";
import { token } from "./token.js";
function Content({
  children
}) {
  return /* @__PURE__ */ jsx(ContentStyled, {
    children
  });
}
const ContentStyled = styled.div.withConfig({
  displayName: "ContentStyled",
  componentId: "sc-wd455t-0"
})(["", " flex-grow:1;overflow-y:auto;padding:", " ", ";overscroll-behavior:contain;"], baseStyles, token.spacing3, token.spacing6);
export {
  Content
};
//# sourceMappingURL=Content.js.map
